module.exports = __webpack_public_path__ + "img/success_checkout.cae41495.svg";